// Which native render path produced the output. `photo-asset` is display-source
// (stale-EXIF-resistant via PhotoKit); `imageio` and `exifinterface` are
// metadata-faithful — they trust the file's EXIF tag and cannot detect a lying
// tag. `fallback` indicates the stub returned the input URI unchanged.
export type NormalizationSource = 'photo-asset' | 'imageio' | 'exifinterface' | 'fallback';

export interface NormalizedImage {
  uri: string;
  width: number;
  height: number;
  orientation: 1;
  source: NormalizationSource;
}

export interface NormalizePickedImageOptions {
  uri: string;
  assetId?: string;
  mimeType?: string;
  maxLongEdge: number;
  quality: number;
}
